import { toNumberFormat } from "../../../utils/numberFormat";

const getHeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_stunted") return "เตี้ยแคระแกร็น";
  if (d === "stunted") return "เตี้ย";
  if (d === "relatively_stunted") return "ค่อนข้างเตี้ย";
  if (d === "normal") return "ตามเกณฑ์";
  if (d === "quite_high") return "ค่อนข้างสูง";
  if (d === "high") return "สูง";

  return "-";
};

const getWeightMeasureText = (d) => {
  if (!d) return "-";
  if (d === "severe_wasted") return "ผอมแห้ง";
  if (d === "wasted") return "ผอม";
  if (d === "relatively_wasted") return "ค่อนข้างผอม";
  if (d === "normal") return "สมส่วน";
  if (d === "buxom") return "ท้วม";
  if (d === "overweight") return "เริ่มอ้วน";
  if (d === "obese") return "อ้วน";

  return "-";
};

const columns = [
  {
    title: "สัปดาห์ที่",
    dataIndex: "week",
    key: "week",
    isShowInFooter: false,
  },
  {
    title: "นมวัวจืด ml/วัน",
    dataIndex: "freshMilkVolume",
    key: "freshMilkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวปรุงแต่ง ml/วัน",
    dataIndex: "flavoredMilkVolume",
    key: "flavoredMilkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมวัวรวม ml/วัน",
    dataIndex: "totalMilkVolume",
    key: "totalMilkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองจืด ml/วัน",
    dataIndex: "soyMilkVolume",
    key: "soyMilkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "นมถั่วเหลืองหวาน ml/วัน",
    dataIndex: "soyMilkSweetVolume",
    key: "soyMilkSweetVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 1 ดื่มดี นมวัว",
    dataIndex: "totalCowMilkScore",
    key: "totalCowMilkScore",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ผัก ช้อน/วัน",
    dataIndex: "totalVegetableQuantity",
    key: "totalVegetableQuantity",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 2 สุขชัวร์ เพิ่มผัก",
    dataIndex: "totalVegetableScore",
    key: "totalVegetableScore",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ออกกำลัง นาที/วัน",
    dataIndex: "totalExerciseMinutes",
    key: "totalExerciseMinutes",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 3 รัก ออกกำลัง",
    dataIndex: "totalExerciseScore",
    key: "totalExerciseScore",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน ml/วัน",
    dataIndex: "normalSweetDrinkVolume",
    key: "normalSweetDrinkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "น้ำหวาน หวานน้อย ml/วัน",
    dataIndex: "lowSweetDrinkVolume",
    key: "lowSweetDrinkVolume",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนรวม เป้าหมายที่ 4 หยุดยั้ง น้ำหวาน",
    dataIndex: "totalSweetDrinkScore",
    key: "totalSweetDrinkScore",
    isShowInFooter: true,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "ส่วนสูง (ซม.)",
    dataIndex: ["nutritionStatus", "height"],
    key: "height",
    render: (v) => <>{toNumberFormat(v)}</>,
    // render: (height) => {
    //   return <>{height ? `${height} ซม.` : ""}</>;
    // },
    isShowInFooter: false,
  },
  {
    title: "น้ำหนัก (กก)",
    dataIndex: ["nutritionStatus", "weight"],
    key: "weight",
    render: (v) => <>{toNumberFormat(v)}</>,
    // render: (weight) => {
    //   return <>{weight ? `${weight} กก.` : ""}</>;
    // },
    isShowInFooter: false,
  },
  {
    title: "ภาวะความสูง",
    dataIndex: ["nutritionStatus", "heightForAge"],
    key: "heightForAge",
    render: (heightForAge) => {
      return <>{getHeightMeasureText(heightForAge)}</>;
    },
    isShowInFooter: false,
  },
  {
    title: "ภาวะน้ำหนักตัว",
    dataIndex: ["nutritionStatus", "weightForHeight"],
    key: "weightForHeight",
    render: (weightForHeight) => {
      return <>{getWeightMeasureText(weightForHeight)}</>;
    },
    isShowInFooter: false,
  },
  {
    title: "จำนวนข้อมูลที่กรอก (วัน)",
    dataIndex: "days",
    key: "days",
    isShowInFooter: false,
  },
  {
    title: "รางวัลที่ได้รับ",
    dataIndex: "rewards",
    key: "rewards",
    render: (rewards) => {
      return <span>{rewards && rewards.join(", ")}</span>;
    },
    isShowInFooter: false,
  },
  {
    title: "Rank โรงเรียน",
    dataIndex: ["rank", "allSchool"],
    key: "rank",
    isShowInFooter: false,
    render: (v) => <>{toNumberFormat(v)}</>,
  },
  {
    title: "คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScore",
    key: "quizScore",
    render: (quizScore) => <>{toNumberFormat(quizScore)}</>,
  },
  {
    title: "% คะแนนการทำแบบทดสอบชุดความรู้",
    dataIndex: "quizScorePercent",
    key: "quizScorePercent",
    render: (quizScorePercent) => <>{toNumberFormat(quizScorePercent)}</>,
  },
];

export { columns };
